// extracted by mini-css-extract-plugin
export default {"modalMessage":"InviteSellerButton_modalMessage__CvzmB","modalTitle":"InviteSellerButton_modalTitle__wR3Cj","countSeller":"InviteSellerButton_countSeller__Ye3nd"};